// extracted by mini-css-extract-plugin
module.exports = {"FormBody":"SettingForm_FormBody__nhocH","PanelBody":"SettingForm_PanelBody__9UqJt","Controls":"SettingForm_Controls__36IFO"};